// InstagramBusinessConnectButton.jsx
import React from "react";

export default function InstagramBusinessConnectButton({
  appUserId,
  user,
  mode,
}) {
  // Das ist deine Instagram-App-ID aus dem Instagram-Produkt im Dashboard:
  const INSTAGRAM_APP_ID = "687638373659171";
  const REDIRECT_URI =
    "https://www.cloud.ditochat.com/api/connections/oauth_instagram_business.php";
  // Neue Scopes laut Business-Login-Dokumentation:
  const SCOPES = [
    "instagram_business_basic",
    "instagram_business_content_publish",
    "instagram_business_manage_comments",
    "instagram_business_manage_messages",
  ].join(",");

  // Umgebung, kann später auf "test" umgeschaltet werden:
  const ENVIRONMENT = mode;

  // Wir kodieren environment + userId als JSON im state-Parameter:
  const STATE = encodeURIComponent(
    JSON.stringify({
      environment: ENVIRONMENT,
      userId: user?.id,
    })
  );

  // Instagram-Business-Login URL
  const authUrl =
    `https://www.instagram.com/oauth/authorize` +
    `?client_id=${INSTAGRAM_APP_ID}` +
    `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
    `&scope=${encodeURIComponent(SCOPES)}` +
    `&response_type=code` +
    `&state=${STATE}` +
    `&enable_fb_login=1`; // optional, falls du Facebook-Seiten-Login erlauben willst

  const handleClick = () => {
    // Merke dir die Nutzer-ID fürs Backend
    sessionStorage.setItem("appUserId", appUserId);
    window.location.href = authUrl;
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        marginTop: "8px",
      }}
      onClick={handleClick}>
      + Mit Instagram verbinden {mode}
    </div>
  );
}
